import { getCurrentUserId } from '../../../common/utils';

export default function (resourceOwnerUserId) {
  const currentUserId = getCurrentUserId();
  return Boolean(resourceOwnerUserId) && resourceOwnerUserId === currentUserId;
}